import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import PlumbingHero from './components/PlumbingHero';
import PlumbingServices from './components/PlumbingServices';
import PlumbingSystemsElPaso from './components/PlumbingSystemsElPaso';
import ContractorDirectory from './components/ContractorDirectory';
import ComparisonChecklist from './components/ComparisonChecklist';
import PlumbingFAQ from './components/PlumbingFAQ';

export default function PlumbingPage() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Header />
      <main>
        <PlumbingHero />
        <PlumbingServices />
        <PlumbingSystemsElPaso />
        <ContractorDirectory />
        <ComparisonChecklist />
        <PlumbingFAQ />
      </main>
      <Footer />
    </div>
  );
}
